import { Component, Input, OnInit } from '@angular/core';

import { GoogleAnalyticsService } from '@app/services/_index';
import { SubscriptionTilesFactory } from '@app/factories/_index';
import { SubscriptionTilesItem } from '@app/models/_index';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-legacy-subscription-tiles',
  templateUrl: './legacy-subscription-tiles.component.html',
  styleUrls: ['./legacy-subscription-tiles.component.scss'],
  standalone: false,
})
export class LegacySubscriptionTilesComponent implements OnInit {
  @Input() isLightMode = false; // Toggle to change background styling from light or dark
  subscriptionTiles: SubscriptionTilesItem[] = [];

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private subscriptionTilesFactory: SubscriptionTilesFactory
  ) {}

  ngOnInit(): void {
    this.subscriptionTiles = this.subscriptionTilesFactory.getCollection();
  }

  /**
   * Add Track By Subscription Tile Item to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of subscriptionTileItem array
   * @param item - Subscription Tile item
   * @returns enrollment id
   */
  trackBySubscriptionTileItem(index: string, subscriptionItem: SubscriptionTilesItem): string {
    if (subscriptionItem) {
      return subscriptionItem.slug;
    } else {
      return String(index);
    }
  }

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }
}
